export default ({ theme }) => ({
    cursor: 'move',
    padding: '1rem 0',
    backgroundColor: theme.colors.white,
    '& .dragger': {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        '& .anticon': {
            fontSize: '1rem',
        },
    },
    '& .draggable': {
        paddingLeft: '1rem',
        borderLeft: `1px solid ${theme.colors.lightGrey}`,
    },
    '& .add-info': {
        margin: '0.5rem 0 0 2rem',
    },
    '& .delete-info-category': {
        margin: '0.5rem 0 0 1rem',
    },
    '& .ant-divider': {
        marginBottom: '0',
    },
});
